// Beacon design tokens used by the AHA eCard setup screens (design handoff: AHA eCard Setup Redesign).
export const AHA_TOKENS = {
  ink: "#150f23",
  violet: "#6a5fc1",
  muted: "#79628c",
  lime: "#c2ef4e",
  limeInk: "#3d4d0c",
  hairlineCloud: "#e5e7eb",
  hairlineCool: "#cfcfdb",
  press: "#f0f0f0",
  subtle: "#faf9fb",
  success: "#15803d",
  successBg: "rgba(21,128,61,.10)",
  warn: "#c2410c",
  warnBg: "rgba(194,65,12,.10)",
  danger: "#b42318",
  dangerBg: "rgba(180,35,24,.08)",
  ring: "rgba(59,130,246,.5)",
  aha: "#880e4f",
  card: "0 1px 0 rgba(20,24,40,.04), 0 1px 3px rgba(20,24,40,.06)",
  popover: "0 10px 15px -3px rgba(0,0,0,.1), 0 4px 6px -4px rgba(0,0,0,.1)",
};

export const FOCUS_RING = { boxShadow: "0 0 0 3px rgba(59,130,246,.5)", borderRadius: "6px" };
